import "./SideBar.scss"
import React from "react"
import classnames from "classnames"
import { observer } from "mobx-react"
import { Route, Link } from "react-router-dom"
import { Icon, TeamIcon, Scroll } from "../lib"
import { authStore, teamStore } from "../app/stores"

const SideBarLink = ({ to, exact, ...rest }) => (
  <Route
    exact={exact}
    path={to}
    children={({ match }) => (
      <Link
        {...rest}
        className={classnames("SideBarLink", match && "SideBarLink-active")}
        to={to}
      />
    )}
  />
)

const SideBar = () => {
  return (
    <nav className="SideBar">
      <Scroll>
        <header className="SideBar_header">
          {authStore.userName && <h4>Hi, {authStore.userName}</h4>}
          <h3>
            <TeamIcon size={40} />
            <span>{teamStore.teamName}</span>
          </h3>
        </header>
        <ul className="SideBar_links">
          <h5>Smallchat</h5>
          <li>
            <SideBarLink to="/dashboard">
              <Icon name="analytics" /> Dashboard
            </SideBarLink>
          </li>
          <li>
            <SideBarLink to="/account">
              <Icon name="billing" /> Account
            </SideBarLink>
          </li>
        </ul>
        <ul className="SideBar_channels">
          <h5>Channels</h5>
          <li>
            <SideBarLink to="/add">
              <Icon name="plus" /> Add a channel
            </SideBarLink>
          </li>
          {teamStore.activeChannels.map(channel => (
            <li key={channel.key}>
              <SideBarLink to={`/channel/${channel.key}`}>
                <Icon name="slack" /> {channel.name}
              </SideBarLink>
            </li>
          ))}
          {teamStore.archivedCount > 0 &&
            teamStore.showArchived &&
            teamStore.archivedChannels.map(channel => (
              <li key={channel.key}>
                <SideBarLink to={`/channel/${channel.key}`}>
                  <Icon name="archive" /> {channel.name}
                </SideBarLink>
              </li>
            ))}
          {teamStore.archivedCount > 0 && (
            <li>
              <a
                className="SideBar_channels_toggle"
                onClick={teamStore.toggleArchivedVisibility}>
                {teamStore.showArchived ? (
                  "Hide archived channels"
                ) : (
                  "Show archived channels"
                )}
              </a>
            </li>
          )}
        </ul>
        <ul className="SideBar_links">
          <h5 />
          <li>
            <a
              className="SideBarLink"
              href="https://docs.small.chat/"
              target="_blank">
              <Icon name="documentation" /> Docs ↗
            </a>
          </li>
          <li>
            <a onClick={authStore.logout} className="SideBarLink">
              <Icon name="logout" /> Logout
            </a>
          </li>
        </ul>
        {/* <footer className="SideBar_footer">
          <a
            href="https://docs.small.chat/"
            target="_blank"
            className="SideBarLink">
            <Icon name="documentation" /> Documentation
          </a>
          <a onClick={authStore.logout} className="SideBarLink">
            <Icon name="logout" /> Logout
          </a>
        </footer> */}
      </Scroll>
    </nav>
  )
}

SideBar.displayName = "SideBar"

export default observer(SideBar)



// WEBPACK FOOTER //
// ./src/app/SideBar.js